export const classes = {
  wrapper: 'w-full grid grid-cols-2 gap-4',
  fieldWrapper: 'flex flex-col',
  label: 'text-sm font-semibold text-grey-8 dark:text-mauve-1 mb-1 ml-1',
  option: 'grow py-1',
};

export const styles = {
  option: (count: number) => ({
    width: `calc(100% / ${count} - 0.75rem)`,
  }),
};
